var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconPlus = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2 10.8572H16.8V13.143H13.2V16.5715H10.8V13.143H7.19999V10.8572H10.8V7.42868H13.2V10.8572ZM12 21.143C6.7068 21.143 2.40001 17.0413 2.40001 12.0001C2.40001 6.95896 6.7068 2.85725 12 2.85725C17.2932 2.85725 21.6 6.95896 21.6 12.0001C21.6 17.0413 17.2932 21.143 12 21.143ZM12 0.571533C5.3724 0.571533 0 5.68811 0 12.0001C0 18.3121 5.3724 23.4287 12 23.4287C18.6276 23.4287 24 18.3121 24 12.0001C24 5.68811 18.6276 0.571533 12 0.571533Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconPlus);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_plus.874c93e5b033953160b8b7a64fc7b5a3.svg";